import { render, staticRenderFns } from "./ServicesTabMailQueue.vue?vue&type=template&id=e89a5c6e&scoped=true"
import script from "./ServicesTabMailQueue.vue?vue&type=script&lang=ts"
export * from "./ServicesTabMailQueue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89a5c6e",
  null
  
)

export default component.exports